import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../../core/style/gstheme';
import SlatInnerWorkflow from '../../core/SlatInnerWorkflow';
import { isRTL } from '../../core/utils/utils';

class LabelSlat extends React.Component {

    render() {

        const { onSelect, classes, data, selected, workflowStatus } = this.props;
        const lang = Object.keys(data.literalForm)[0];
        const rtl = isRTL(lang);

        return (
            <div data-test="label-slat"
                className={
                    selected ?
                        classes.selectedSlatStyle
                        :
                        classes.slatStyle
                }
                style={{ borderLeft: selected ? 'solid 3px #616161' : 'solid 3px #e5e5e5' }}
                onClick={(ev) => {
                    onSelect(data.id);
                    ev.preventDefault();
                    ev.stopPropagation();
                }}>
                <Typography
                    data-test={selected ?
                        "selected-label-inner"
                        :
                        "label-inner"
                    }
                    dir={rtl ? "rtl" : null}
                    lang={lang}
                    className={selected ? classes.selectedSlat : classes.slat}>
                    {data.literalForm[lang] || 'No literal form'}
                </Typography>
                <div style={{ float: 'right', width: 1 }}>
                    {workflowStatus ?
                        <SlatInnerWorkflow workflowStatus={workflowStatus} />
                        :
                        null
                    }
                </div>
            </div>
        );
    }
}

LabelSlat.defaultPropes = {
    selected: false
};

LabelSlat.propTypes = {
    classes: PropTypes.object,
    schemeIRI: PropTypes.string,
    workflowStatus: PropTypes.string,
    selected: PropTypes.bool,
    data: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired
};

export default withStyles(styles)(LabelSlat);